module.exports = __webpack_public_path__ + "img/ETC.373cb189.svg";